export class Concours {
    constructor(
        public id?: number,
        public passage?: boolean,
        public resultat?: number,
        public admissible?: boolean,
        public rang?: number,
        public annee?: number,
        public candidatureId?: number,
        public typeConcoursId?: number,
        public typeConcours?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/concours.model.ts